module.exports = __webpack_public_path__ + "static/9-28a5f32cf553f2d1e69da2975737f1c2.png";